import { Group, Title, Button, Breadcrumbs, Anchor, Stack, Text } from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";

export function PageHeader({ title, subtitle, backTo, backLabel, onBackClick, breadcrumbs, actions, status }) {
  const navigate = useNavigate();

  return (
    <Stack spacing="xs" mb="xl">
      {breadcrumbs && (
        <Breadcrumbs>
          {breadcrumbs.map((item, index) => (
            <Anchor key={index} component={Link} to={item.to} size="sm" c={index === breadcrumbs.length - 1 ? "dimmed" : undefined}>
              {item.label}
            </Anchor>
          ))}
        </Breadcrumbs>
      )}

      <Group justify="space-between" align={subtitle ? "flex-start" : "center"}>
        <Group align="center">
          {(backTo || onBackClick) && (
            <Button variant="subtle" leftSection={<IconArrowLeft size={16} />} onClick={() => (onBackClick ? onBackClick() : navigate(backTo))}>
              {backLabel || "Back"}
            </Button>
          )}
          <div>
            <Title order={2}>{title}</Title>
            {subtitle && (
              <Text c="dimmed" size="sm">
                {subtitle}
              </Text>
            )}
          </div>
        </Group>

        {(actions || status) && (
          <Group>
            {status}
            {actions}
          </Group>
        )}
      </Group>
    </Stack>
  );
}

export default PageHeader;
